import React, { useState, useEffect } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

const TemplateManager = () => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    type: 'email',
    subject: '',
    content: ''
  });

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens.idToken.toString();
      
      const response = await fetch('https://hjjtpav7x0.execute-api.us-east-1.amazonaws.com/prod/admin/templates', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setTemplates(data);
      }
    } catch (error) {
      console.error('Error fetching templates:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const session = await fetchAuthSession();
      const token = session.tokens.idToken.toString();
      
      const url = selectedTemplate 
        ? `https://hjjtpav7x0.execute-api.us-east-1.amazonaws.com/prod/admin/templates/${selectedTemplate.templateId}`
        : 'https://hjjtpav7x0.execute-api.us-east-1.amazonaws.com/prod/admin/templates';
      
      const method = selectedTemplate ? 'PUT' : 'POST';
      
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });
      
      if (response.ok) {
        fetchTemplates();
        resetForm();
      }
    } catch (error) {
      console.error('Error saving template:', error);
    }
  };

  const handleDelete = async (templateId) => {
    if (!window.confirm('Are you sure you want to delete this template?')) return;
    
    try {
      const session = await fetchAuthSession();
      const token = session.tokens.idToken.toString();
      
      const response = await fetch(`https://hjjtpav7x0.execute-api.us-east-1.amazonaws.com/prod/admin/templates/${templateId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        fetchTemplates();
        resetForm();
      }
    } catch (error) {
      console.error('Error deleting template:', error);
    }
  };

  const resetForm = () => {
    setFormData({ name: '', type: 'email', subject: '', content: '' });
    setSelectedTemplate(null);
    setIsEditing(false);
  };

  const editTemplate = (template) => {
    setSelectedTemplate(template);
    setFormData({
      name: template.name,
      type: template.type,
      subject: template.subject || '',
      content: template.content
    });
    setIsEditing(true);
  };

  return (
    <div className="settings-view">
      <h2>Template Manager</h2>
      
      <div className="settings-section">
        <h3>{isEditing ? 'Edit Template' : 'Create New Template'}</h3>
        <form onSubmit={handleSubmit}>
          <div className="setting-item">
            <label htmlFor="templateName">Name:</label>
            <input
              id="templateName"
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              required
            />
          </div>
          
          <div className="setting-item">
            <label htmlFor="templateType">Type:</label>
            <select
              id="templateType"
              value={formData.type}
              onChange={(e) => setFormData({...formData, type: e.target.value})}
            >
              <option value="email">Email</option>
              <option value="sms">SMS</option>
            </select>
          </div>
          
          {formData.type === 'email' && (
            <div className="setting-item">
              <label htmlFor="templateSubject">Subject:</label>
              <input
                id="templateSubject"
                type="text"
                value={formData.subject}
                onChange={(e) => setFormData({...formData, subject: e.target.value})}
              />
            </div>
          )}
          
          <div className="setting-item">
            <label htmlFor="templateContent">Content:</label>
            <textarea
              id="templateContent"
              value={formData.content}
              onChange={(e) => setFormData({...formData, content: e.target.value})}
              rows="10"
              required
              style={{ width: '100%', minHeight: '200px' }}
            />
            {formData.type === 'sms' && (
              <div style={{ 
                fontSize: '12px', 
                color: formData.content.length > 160 ? '#e74c3c' : '#666',
                marginTop: '5px'
              }}>
                {formData.content.length}/160 characters
                {formData.content.length > 160 && (
                  <span style={{ color: '#e74c3c', marginLeft: '10px' }}>
                    ({Math.ceil(formData.content.length / 160)} SMS segments)
                  </span>
                )}
              </div>
            )}
          </div>
          
          <div className="settings-actions">
            <button type="submit" className="save-settings-btn">
              {isEditing ? 'Update Template' : 'Create Template'}
            </button>
            <button type="button" onClick={resetForm} style={{ marginLeft: '10px' }}>
              Cancel
            </button>
          </div>
        </form>
      </div>
      
      <div className="settings-section">
        <h3>Existing Templates</h3>
        <div className="leads-table" style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Subject</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {templates.map(template => (
                <tr key={template.templateId}>
                  <td>{template.name}</td>
                  <td>{template.type}</td>
                  <td>{template.subject || 'N/A'}</td>
                  <td>
                    <button 
                      onClick={() => editTemplate(template)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', marginRight: '8px' }}
                      title="Edit template"
                    >
                      ✏️
                    </button>
                    <button 
                      onClick={() => handleDelete(template.templateId)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px' }}
                      title="Delete template"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TemplateManager;
